//import $ from 'jquery';
import DOMHelpers from '../utils/dom-helpers';
import { debounce as _debounce } from 'es-toolkit';
// import { gsap } from 'gsap';

// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay, Keyboard, Mousewheel } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import 'lazysizes';


export default class {

	constructor(options) {

		// OPTIONS
		this.defaults = {
			fixedHeight: false,
			spaceBetween: 20,
			addSlidesForLoop: true,
			args: false
		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = 'slideshow_wiper';

		// DOM ELEMENT !!!!!!!!!!
		this.$el = this.options.$el;


		// vars
		/*
		this.$win = $(window);
		this.$doc = $(document);
		this.$html = $('html');
		this.$body = $('body');
		this.touch = !$('html').hasClass('no-touch');
		*/

		// DOM helpers
		this.dom = new DOMHelpers(document);

		// VARS (vanilla DOM)
		this.window = window;
		this.document = document;
		this.htmlEl = document.documentElement;
		this.body = document.body;

		// convenience shorthands
		this.qs = this.dom.qs.bind(this.dom);
		this.qsa = this.dom.qsa.bind(this.dom);
		this.on = this.dom.on.bind(this.dom);
		this.off = this.dom.off.bind(this.dom);
		this.addClass = this.dom.addClass.bind(this.dom);
		this.removeClass = this.dom.removeClass.bind(this.dom);
		this.hasClass = this.dom.hasClass.bind(this.dom);
		this.htmlToDoc = this.dom.htmlToDoc.bind(this.dom);
		

		//console.log( "Slideshow Swiper", this.$el );

		this.width = this.window.innerWidth;

		// init!!!!
		this.init(true);

	}

	init(b) {
		this.addEvents(b);
		this.initSlider(b);
	}

	initSlider(b) {
		if (b) {

			// Get all your custom pagination bullets
			//this.customBullets = this.$el.parentNode.querySelectorAll('.custom-pagination .custom-bullet');

			let args = {
				/*
				grabCursor: true,
				  freeMode: {
					enabled: true,
					sticky: true
					},		
				*/
				modules: [Navigation, Pagination, EffectFade, Autoplay, Keyboard, Mousewheel],

				
				pagination: {
					el: this.$el.parentNode.querySelector(".swiper-pagination"),
					type: "bullets",
					clickable: true,
					enabled: true,
				},
				

				// Add event listener to handle custom pagination
				/*
				on: {
					// This event fires after a slide change has occurred
					slideChange:()=> {
						//console.log( this.swiper );
						// Get the real index of the current slide
						const realIndex = this.swiper.realIndex;

						console.log( realIndex );

						// Remove the active class from all custom bullets
						this.customBullets.forEach(bullet => {
							bullet.classList.remove('is-active');
						});

						// Add the active class to the corresponding bullet
						this.customBullets[realIndex].classList.add('is-active');
					},
					// Set the initial state on Swiper initialization
					init: ()=> {
						this.customBullets[this.swiper.realIndex].classList.add('is-active');
					},
				},
				*/

				navigation: {
					nextEl: this.$el.parentNode.querySelector(".swiper-button-next"),
					prevEl: this.$el.parentNode.querySelector(".swiper-button-prev"),
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
					pageUpDown: true
				},
				mousewheel: false,
				effect: 'slide',
				/*
				virtual: {
					enabled: true
				},
				*/
				//loop: true,
				//slidesPerView: 'auto',
				//centerInsufficientSlides: true,
				//parallax: true,
				slidesPerView: 1,

				spaceBetween: this.options.spaceBetween || 20,
				breakpoints: {
					768: {
						spaceBetween: 30
					},
					1024: {
						spaceBetween: 40
					},
					1400: {
						spaceBetween: 60
					}
				},

				speed: 800,

				init: false,

			};

			if ( this.hasClass(this.$el, 'slider-fade' ) ){
				
				args.effect = "fade";
				args.fadeEffect = { crossFade: false };	
				args.slidesPerView = 1;
				args.speed = 1200;
				//this.addClass( this.$el, 'overflow-visible' );
			}

			if ( this.hasClass(this.$el, 'slider-cross-fade' ) ){
				args.fadeEffect = { crossFade: true };
			}

			if ( this.hasClass(this.$el, 'slider-fade-and-mobile-slide' ) ){
				
				if ( window.innerWidth < 768 ){
					args.effect = "slide";
					args.slidesPerView = 1;
					args.spaceBetween = 20;
					args.speed = 600;
					//this.addClass( this.$el, 'overflow-visible' );
				}
				else{
					args.effect = "fade";
					args.fadeEffect = { crossFade: false };	
					args.slidesPerView = 1;
					args.speed = 1200;
					
					//this.addClass( this.$el, 'overflow-visible' );
				}
			}

			if( this.hasClass(this.$el, 'slider-strip-auto') ){
				args.slidesPerView = 3.3; //'auto';
				if ( this.hasClass( this.$el, 'slider-initiative' ) ){

					//console.log( 'quiii' );

					args.slidesPerView = 'auto';
					args.speed 	= 1000;
					args.slidesOffsetBefore = this.getSlidesOffset( 'before' );
					args.slidesOffsetAfter 	= this.getSlidesOffset( 'after' );
					args.autoplay = {
						delay: 6000, 
					}
					// args.centerInsufficientSlides = true;


					/*
					args.slidesPerView = 1.15;
					args.centeredSlides = false;
					args.speed 	= 1000;
					args.slidesOffsetBefore = this.getSlidesOffset( 'before' );
					args.slidesOffsetAfter 	= this.getSlidesOffset( 'after' );
					args.autoplay = {
						delay: 6000, 
					}
					args.breakpoints = {
						768: {
							spaceBetween: 30,
						},
						1024: {
							spaceBetween: 40,
							slidesPerView: 1.4
						},
						1400: {
							spaceBetween: 60,
							slidesPerView: 1.8
						},
						1800: {
							spaceBetween: 60,
							slidesPerView: 2.4
						}
					};
					*/
				}
				/*
				if ( this.hasClass( this.$el, 'slider-instagram' ) ){
					args.slidesPerView = 1.3;

					args.breakpoints = {
						768: {
							spaceBetween: 30,
							slidesPerView: 3.7
						},
						1024: {
							spaceBetween: 40,
							slidesPerView: 3.7
						},
						1400: {
							spaceBetween: 60,
							slidesPerView: 4.7
						}
					};

				}
				*/
			}

			
			if ( this.hasClass(this.$el, 'slider-autoplay' ) ){
				args.autoplay = {
					// time between transitions
					delay: 4000, 
					// Restart autoplay after user interaction
    				disableOnInteraction: false,
					pauseOnMouseEnter: true
				};
			}

			if ( this.hasClass(this.$el, 'slider-loop' ) ){

				let max = this.qsa('.swiper-slide', this.$el).length;

				if ( max > 1 ){

					args.loop = true;

					// adsd slide if insufficiwnt for loop
					if( this.options.addSlidesForLoop ){
						if ( args.effect === "slide" && args.slidesPerView > 1 ){
							
							if ( max > 1 && max < 3 ){
								for( let i=0; i < max; i++ ){
									this.$el.querySelector('.swiper-wrapper').append( this.qsa('.swiper-slide', this.$el)[0].cloneNode(true) );
									this.$el.querySelector('.swiper-wrapper').append( this.qsa('.swiper-slide', this.$el)[1].cloneNode(true) );
								}
								// for now hide pagination whch is incorrect if duplicate slides for the loop that are counted as real slides
								args.pagination = { enabled: false };
							}
						}
					}

				}
				else{
					args.loop = false
				}
			}

			if ( this.hasClass( this.$el, 'slider-no-interaction') ){
				args.allowTouchMove = false;
			}

			if ( this.hasClass( this.$el, 'slider-no-arrows' ) ){
				args.navigation = { enabled: false };
			}
			if ( this.hasClass( this.$el, 'slider-no-dots' ) ){
				args.pagination = { enabled: false };
			}

			//----------------------------------------------[ SPECIFIC ]---------------------------------------------------//

			if ( this.hasClass( this.$el, 'slider-main-promos-home' ) ){
				args.autoplay.delay = 6000
			}

			/*
			if ( this.hasClass( this.$el, 'slider-related-mobile' ) ){
				args.slidesPerView = 2; //'auto';
				args.spaceBetween = 0;
				args.breakpoints[768].slidesPerView = 4;
				args.breakpoints[768].spaceBetween = 0;
				args.slidesOffsetAfter = this.window.innerWidth < 768 ? 80 : 210;
			}
			*/

			if ( this.hasClass(this.$el, 'slider-initiatives-home' ) ){
				let n = this.qsa('.swiper-slide', this.$el).length;
				if ( n > 3 ){
					args.slidesPerView = 3.3;
					args.loop = true;
				}
				else{
					args.slidesPerView = 3;
				}
			}

			if ( this.hasClass(this.$el, 'slider-bio' ) ){
				args.autoHeight = true;
			}

			//console.log( args );

			if ( this.options.args ){
				args = this.options.args;
			}


			this.swiper = new Swiper(this.$el, args);


			this.addCustomeEventsSwiper( true );

			//swiper.on('init', () => { setTimeout(() => { lazySizes.autoSizer.checkElems() }, 1000); });
			//swiper.on('afterInit', () => { setTimeout(() => { lazySizes.autoSizer.checkElems() }, 2000); });

	
			//console.log( args );

			this.swiper.init();

			if ( this.hasClass( this.$el, 'slider-main-promos-home' ) ){
				this.autoPlay(false);
			}

			
		}
		else {

			if (this.swiper) {
				this.addCustomeEventsSwiper( false );
				this.swiper.destroy(true, true);
			}
		}
	}

	autoPlay( b = true ){
		if ( b ){
			this.swiper.autoplay.start();
		}
		else{
			this.swiper.autoplay.stop();
		}
	}


	addEvents(b) {
		this.debounceResize(b);
		this.attachEventsKeyBoard(b);
	}

	addCustomeEventsSwiper(b){
		if ( b ){
			this.swiper.on( 'init', this.onInit );
		}
		else{
			this.swiper.off( 'init', this.onInit );
		}
	}

	onInit = () => {

		this.checkNavigationAndPagination()

		if ( this.hasClass( this.$el, 'slider-initiative' ) ) {
			this.alignSliderCenteredAtTheLeftEdge()
		}
	}

	checkNavigationAndPagination(){

		if ( this.dom.hasClass( this.$el, 'swiper-navigation-disabled' ) ){
			this.dom.addClass( this.$el.parentNode, 'swiper-navigation-disabled' );
		}
		if ( this.dom.hasClass( this.$el, 'swiper-pagination-disabled' ) ){
			this.dom.addClass( this.$el.parentNode, 'swiper-pagination-disabled' );
		}

	}

	debounceResize(b) {
		if (b) {
			// debounce resize
			this._debResize = _debounce(() => this.onResize(true), 47 );
			window.addEventListener('resize', this._debResize);
		}
		else {
			if (this._debResize) {
				this._debResize.cancel && this._debResize.cancel();
				window.removeEventListener('resize', this._debResize);
			}
		}
	}

	onResize() {

		// avoid re-initializing on same width (scroll on iOS can trigger resize events)
		let w = this.window.innerWidth;
		if ( w === this.width ){
			return;
		}
		this.width = w;

		if ( this.hasClass(this.$el, 'slider-fade-and-mobile-slide' ) ){
			this.initSlider( false );

			/*
			this.$el.querySelectorAll( '.swiper-slide' ).forEach( (el,i) => {
				el.style.width = el.querySelector( '.sizer' ).getBoundingClientRect().width + 'px';
			});
			*/
			
			this.initSlider( true );
			return;
		}

		if ( this.hasClass( this.$el, 'slider-initiative' ) && !this.swiper.passedParams.centeredSlides ){
			this.initSlider( false );
			this.initSlider( true );
			return;
		}


		/*
		if (this.options.fixedHeight) {
			let ww = 0, $el, orw, orh, w, h, $s;
			this.$el.find('.swiper-slide .img-wrapper').each((i, el) => {

				$el = $(el);

				orw = parseInt($el.attr('data-width'));
				orh = parseInt($el.attr('data-height'));


				h = $el.parents('.img-sizer').height();
				w = orw * h / orh;

				$s = $el.parents('.swiper-slide');
				$s.width(w);


				$el.height(h - 10);

				$el.find('img').css({
					height: 2 * (h - 10),
					width: 'auto' //2*w 
				});


				ww += $s.outerWidth();

			});
		}
			*/
		lazySizes.autoSizer.checkElems();

		if ( this.hasClass( this.$el, 'slider-initiative' ) ) {
			this.alignSliderCenteredAtTheLeftEdge()
		}

	}

	alignSliderCenteredAtTheLeftEdge(){
		
		if ( !this.swiper.passedParams.centeredSlides ){
			return;
		}


		const 	slides 		= this.$el.querySelectorAll( '.swiper-slide' ),
				// first slide
				firstSlide 	= slides[0],
				lastSlide	= slides[slides.length-1],
				// window width
				ww 			= this.window.innerWidth,
				// arrows
				aLeft 		= this.$el.parentNode.querySelector( '.swiper-button-prev' ),
				aRight		= this.$el.parentNode.querySelector( '.swiper-button-next' ),
				// slide width
				w 			= firstSlide.getBoundingClientRect().width,
				// wrap margin
				margin 		= parseInt( getComputedStyle( document.querySelector( '.wrap' ) )[ 'marginLeft' ] ),
				// wrap width
				wWrap 		= ww - 2*margin,
				// max width
				maxW 		= parseInt( getComputedStyle( document.querySelector( '.max-width' ) )[ 'maxWidth' ] );

		
				
			// change the first slide margin to align from center to the edge of the wrap		
			let m = ww < maxW ? (wWrap - w)/2 :  (wWrap - w)/2 - (ww-maxW)/2;	
			firstSlide.style.marginLeft = -m + 'px';


		// position of the arrows to the edge of the wrap
		let x = ww < maxW ? margin : (ww-maxW+2*margin)/2;
		aLeft.style.left 				= x + 'px';
		aRight.style.right 				= x + 'px';
	}

	getSlidesOffset( which='before' ){
		const 	slides 		= this.$el.querySelectorAll( '.swiper-slide' ),
				// first slide
				firstSlide 	= slides[0],
				// window width
				ww 			= this.window.innerWidth,
				// arrows
				aLeft 		= this.$el.parentNode.querySelector( '.swiper-button-prev' ),
				aRight		= this.$el.parentNode.querySelector( '.swiper-button-next' ),
				// slide width
				w 			= firstSlide.getBoundingClientRect().width,
				// wrap margin
				margin 		= parseInt( getComputedStyle( document.querySelector( '.wrap' ) )[ 'marginLeft' ] ),
				// wrap width
				wWrap 		= ww - 2*margin,
				// max width
				maxW 		= parseInt( getComputedStyle( document.querySelector( '.max-width' ) )[ 'maxWidth' ] );


		let offset = ww < maxW ? margin :  ( ww - maxW )/2 + margin;	

		// position of the arrows to the edge of the wrap
		let x = ww < maxW ? margin : (ww-maxW+2*margin)/2;
		aLeft.style.left 				= x + 'px';
		aRight.style.right 				= x + 'px';


		if ( which == 'after' ){
			//offset = 0;
		}

		return offset;

	}

	attachEventsKeyBoard(b) {
		if (b) {
		}
		else {
		}
	}


	// public methods //////////////////////////////////////////////////////////////////////////
	destroy() {
		this.init(false);
	}

}
